// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  background: radial-gradient(
    ellipse at top,
    var(--color-navy-600) 0%,
    var(--brand-primary) 60%,
    var(--brand-primary) 100%
  );
  color: var(--text-on-dark);
  padding: 4rem 1.25rem 5rem;
  text-align: center;
  border-bottom: 3px solid var(--interactive);
}

.header__inner {
  max-width: 860px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.header__logo {
  width: 140px;
  height: 140px;
  border-radius: var(--radius-pill);
  object-fit: cover;
  box-shadow: var(--shadow-lg);
  border: 2px solid var(--interactive);
}

.header__tagline {
  font-size: 0.9rem;
  letter-spacing: 0.3em;
  text-transform: uppercase;
  color: var(--interactive);
  margin-top: 0.5rem;
}

.header__title {
  font-size: clamp(1.75rem, 4vw, 2.75rem);
  font-weight: 700;
  line-height: 1.15;
  color: var(--color-cream-200);
}

.header__subtitle {
  max-width: 640px;
  color: var(--text-on-dark);
  opacity: 0.85;
  font-size: 1.05rem;
}

@media (max-width: 720px) {
  .header {
    padding: 2.5rem 1rem 3rem;
  }
  .header__logo {
    width: 108px;
    height: 108px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/Header/Header.css"],"names":[],"mappings":"AAAA;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,0BAA0B;EAC1B,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iCAAiC;EACjC,iBAAiB;EACjB,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,YAAY;IACZ,aAAa;EACf;AACF","sourcesContent":[".header {\n  background: radial-gradient(\n    ellipse at top,\n    var(--color-navy-600) 0%,\n    var(--brand-primary) 60%,\n    var(--brand-primary) 100%\n  );\n  color: var(--text-on-dark);\n  padding: 4rem 1.25rem 5rem;\n  text-align: center;\n  border-bottom: 3px solid var(--interactive);\n}\n\n.header__inner {\n  max-width: 860px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n}\n\n.header__logo {\n  width: 140px;\n  height: 140px;\n  border-radius: var(--radius-pill);\n  object-fit: cover;\n  box-shadow: var(--shadow-lg);\n  border: 2px solid var(--interactive);\n}\n\n.header__tagline {\n  font-size: 0.9rem;\n  letter-spacing: 0.3em;\n  text-transform: uppercase;\n  color: var(--interactive);\n  margin-top: 0.5rem;\n}\n\n.header__title {\n  font-size: clamp(1.75rem, 4vw, 2.75rem);\n  font-weight: 700;\n  line-height: 1.15;\n  color: var(--color-cream-200);\n}\n\n.header__subtitle {\n  max-width: 640px;\n  color: var(--text-on-dark);\n  opacity: 0.85;\n  font-size: 1.05rem;\n}\n\n@media (max-width: 720px) {\n  .header {\n    padding: 2.5rem 1rem 3rem;\n  }\n  .header__logo {\n    width: 108px;\n    height: 108px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
